<script setup lang="ts">
const Icon = useIcon();
import { HistoryIcon } from 'assets/data/icons';
</script>
<template>
  <Icon :path="HistoryIcon" class="w-8" filled />
</template>
